import { render, staticRenderFns } from "./df-card-attachment.vue?vue&type=template&id=e0e82bd4"
import script from "./df-card-attachment.ts?vue&type=script&lang=js&external"
export * from "./df-card-attachment.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports